__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => (typeof console !== "undefined" && console.warn && console.warn(msg));
	var uniqueName = "@amzn/WFMLighthouseHubWebApp";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult.catch(handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@amzn/katal-components-ready", "1.0.1", () => (__webpack_require__.e(227).then(() => (() => (__webpack_require__(36227))))));
			register("@amzn/katal-metrics-driver-sushi", "1.1.1", () => (() => (__webpack_require__(28277))), 1);
			register("@amzn/katal-metrics", "2.1.1", () => (() => (__webpack_require__(95989))), 1);
			register("@amzn/katal-react", "1.3.0", () => (__webpack_require__.e(73).then(() => (() => (__webpack_require__(41073))))));
			register("@amzn/katal-react", "1.3.0", () => (__webpack_require__.e(161).then(() => (() => (__webpack_require__(68161))))));
			register("@amzn/wfm-lighthouse-hub-commons", "1.0.0", () => (() => (__webpack_require__(46123))), 1);
			register("crypto-js", "4.1.1", () => (Promise.all([__webpack_require__.e(354), __webpack_require__.e(480)]).then(() => (() => (__webpack_require__(81354))))));
			register("date-fns", "2.27.0", () => (__webpack_require__.e(188).then(() => (() => (__webpack_require__(44188))))));
			register("i18next-browser-languagedetector", "3.1.1", () => (__webpack_require__.e(357).then(() => (() => (__webpack_require__(57357))))));
			register("i18next-icu", "1.4.2", () => (Promise.all([__webpack_require__.e(72), __webpack_require__.e(374)]).then(() => (() => (__webpack_require__(77072))))));
			register("i18next-xhr-backend", "2.0.1", () => (__webpack_require__.e(329).then(() => (() => (__webpack_require__(91329))))));
			register("i18next", "17.3.1", () => (Promise.all([__webpack_require__.e(504), __webpack_require__.e(17)]).then(() => (() => (__webpack_require__(10005))))));
			register("js-cookie", "2.2.1", () => (() => (__webpack_require__(36808))), 1);
			register("lodash", "4.17.21", () => (() => (__webpack_require__(96486))), 1);
			register("papaparse", "5.3.1", () => (__webpack_require__.e(460).then(() => (() => (__webpack_require__(57460))))));
			register("react-dom", "16.14.0", () => (() => (__webpack_require__(73935))), 1);
			register("react-hot-loader", "4.13.0", () => (__webpack_require__.e(53).then(() => (() => (__webpack_require__(65053))))));
			register("react-i18next", "10.13.2", () => (__webpack_require__.e(358).then(() => (() => (__webpack_require__(90804))))));
			register("react-idle-timer", "4.6.4", () => (Promise.all([__webpack_require__.e(936), __webpack_require__.e(38)]).then(() => (() => (__webpack_require__(71038))))));
			register("react-router-dom", "5.3.0", () => (Promise.all([__webpack_require__.e(382), __webpack_require__.e(337)]).then(() => (() => (__webpack_require__(77382))))));
			register("react", "16.14.0", () => (() => (__webpack_require__(87401))), 1);
			register("react", "16.14.0", () => (() => (__webpack_require__(67294))), 1);
			initExternal(62940);
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};